import styled from 'styled-components';

import { Text } from '@/nova/components';
import { CUST, CUST_ANIM } from '../../../../theme/customizer-tokens';

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const Card = styled.div`
  padding: 14px 16px;
  border: 1px solid ${CUST.cardBorder};
  border-radius: 16px;
  background: ${CUST.cardSurface};
`;

export const Top = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Badge = styled.span<{ $color: string; $bg: string }>`
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  color: ${({ $color }) => $color};
  background: ${({ $bg }) => $bg};
`;

export const Title = styled(Text)`
  flex: 1 1 auto;
  min-width: 0;
  font-size: 15px;
  font-weight: 600;
  color: ${CUST.white};
`;

export const Cols = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 0.8fr;
  gap: 12px;
  margin-top: 12px;
`;

export const Col = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const ColLabel = styled(Text)`
  font-size: 11px;
  color: ${CUST.dnsColLabel};
`;

export const ColRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
`;

export const ColValue = styled(Text)`
  flex: 0 1 auto;
  min-width: 0;
  font-size: 14px;
  color: ${CUST.white};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CopyBtn = styled.button`
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  width: 26px;
  height: 26px;
  border: none;
  border-radius: 7px;
  background: transparent;
  color: ${CUST.dnsCopyIcon};
  cursor: pointer;
  transition: color ${CUST_ANIM.INTERACT_MS}ms ease;

  &:hover {
    color: ${CUST.white};
  }
`;